import { useCallDurationRule } from "@/hooks/useCallDurationRule/useCallDurationRule";
import { useGetLicenses } from "@/hooks/useGetLicenses/useGetLicenses";

import { useCall } from "../useCall/useCall";
import { useTranscriptionRule } from "../useTranscriptionRules/useTranscriptionRules";

export function useSummaryRule() {
  const { isCallDurationLow } = useCallDurationRule();
  const { isAvailableCall } = useTranscriptionRule();
  const { call } = useCall();
  const { hasLicense, loading: licensesLoading } = useGetLicenses();
  const hasAiStandardAccess =
    hasLicense("aircall_ai") || hasLicense("ai_assist_pro");

  const shouldDisplaySummary =
    !licensesLoading &&
    hasAiStandardAccess &&
    isAvailableCall &&
    call?.type !== "voicemail" &&
    !isCallDurationLow;

  return {
    shouldDisplaySummary,
  };
}
